import { Box, Group, Text } from '@mantine/core';

type NarrationDisplayProps = {
  text: string;
  isActive?: boolean;
};

export function NarrationDisplay({ text, isActive = false }: NarrationDisplayProps) {
  if (!text) return null;

  return (
    <Box py="xs">
      <Group gap="xs" wrap="nowrap">
        <Text size="sm" c="dimmed" fs="italic">
          {text}
        </Text>
        {isActive && (
          <Text size="sm" c="dimmed" component="span">
            <span className="loading-dots">...</span>
          </Text>
        )}
      </Group>
    </Box>
  );
}
